<template>
<section class="m-project m-project__container" v-if="list.length > 0">
    <div class="m-project-title">Проекты</div>
    <div class="m-project-list">
        <div class="m-project-list__wrapper" v-for="item in filterList">
            <div class="m-project-list__title">{{ item.title }}</div>
            <div class="m-project-list__area">{{ item.value }}</div>
        </div>
    </div>
    <show-more-btn @show-more="showMore" :isLoading="isLoading" v-if="listCount < list.length"></show-more-btn>
</section>
</template>

<script>
import ShowMoreBtn from './ShowMoreBtn.vue'
import { mapState } from 'vuex';

export default {
    name: 'Project',
    components: { ShowMoreBtn },
    props: {},

    data() {
        return {
            listCount: 3,
            isLoading: false
        };
    },
    watch: {
        // Здесь можно добавить наблюдатели
    },

    beforeCreate() {
        // Вызывается до создания экземпляра компонента
    },

    created() {
        // Вызывается после создания экземпляра компонента
    },

    beforeMount() {
        // Вызывается перед монтированием компонента
    },

    mounted() {
        // Вызывается после монтирования компонента
    },

    computed: {
        // Здесь можно добавить вычисляемые свойства
        ...mapState({
            list: state => state.data.props.projects,
        }),
        filterList() {
            return this.list.slice(0, this.listCount);
        }
    },
    methods: {
        // Здесь можно добавить методы
        showMore() {
            this.isLoading = true;
            setTimeout(() => {
                this.listCount += this.listCount;
                this.isLoading = false;
            }, 300)
        },
    }
}; 1
</script>